import React from "react";
import { CardContent, Typography, Grid } from "@mui/material";
import SvgIcon from "./SvgIcon";
import {
  StyleCard,
  StyleHeading,
  StyleSuccessTypography,
  StyleTypography,
} from "../assets/js/Theme";
import { commaSeparateFormat, dateFormat } from "../resources/utils";
import { injectIntl } from "react-intl";
function CardTheme2(props) {
  const { intl, data, name, labels } = props;
  return (
    <StyleCard variant="outlined" className={`card--wrapper-design-2 ${name}`}>
      <CardContent>
        <StyleHeading
          color="primary"
          variant="h4"
          className="property--address font-weight-400"
        >
          {data && data.search_value && data.search_value}
        </StyleHeading>
        <hr />
        <StyleSuccessTypography component="strong" variant="body1">
          {`${labels.price}: `}
        </StyleSuccessTypography>
        <StyleSuccessTypography variant="h5">
          {`${intl.formatMessage({
            id: "GENERAL.AED",
          })} `}{" "}
          {data &&
            data.total_sales_price &&
            commaSeparateFormat(data.total_sales_price)}
        </StyleSuccessTypography>
        <hr />
        <StyleTypography color="primary" className="listing--date" gutterBottom>
          <StyleTypography color="primary" component="strong">
            {`${labels.date}: `}
          </StyleTypography>
          {data && dateFormat(data.evidence_date)}
        </StyleTypography>
        {/* <StyleTypography color="primary" gutterBottom>
          <StyleTypography color="primary" component="strong">
            {`${labels.dom}: `}
          </StyleTypography>
          {data && data.days_on_market}
        </StyleTypography> */}

        <Grid
          container
          className="property--info--wrapper"
          alignItems="center"
          justifyContent="flex-start"
        >
          <Grid item xs={"auto"} className="property--info">
            <Typography className="property--icon" component="span">
              <SvgIcon name="type" colorStyle="active--listings--icon" />
            </Typography>
            <StyleTypography className="property--text">
              {data.unit_type}
            </StyleTypography>
          </Grid>
          <Grid item xs={7} className="property--info">
            <Typography className="property--icon" component="span">
              <SvgIcon name="bedroom" colorStyle="active--listings--icon" />
            </Typography>
            <StyleTypography className="property--text">
              {`${data.no_beds_label}`}
            </StyleTypography>
          </Grid>

          <Grid item xs={"auto"} className="property--info unit--size">
            <Typography className="property--icon" component="span">
              <SvgIcon name="size" colorStyle="active--listings--icon" />
            </Typography>
            <StyleTypography className="property--text">
              {`${commaSeparateFormat(data.unit_size_sqft)} (${labels.unit}) ${labels.sqFt
                }`}
            </StyleTypography>
          </Grid>
          {data.plot_size_sqft ? (
            <Grid item xs={"auto"} className="property--info unit--size">
              <Typography className="property--icon" component="span">
                <SvgIcon name="size" colorStyle="active--listings--icon" />
              </Typography>
              <StyleTypography className="property--text">
                {`${commaSeparateFormat(data.plot_size_sqft)} (${labels.plot
                  }) ${labels.sqFt}`}
              </StyleTypography>
            </Grid>
          ) : null}
          {data.floor_level ? (
            <Grid item xs={"auto"} className="property--info">
              <Typography className="property--icon" component="span">
                <SvgIcon name="floor" colorStyle="active--listings--icon" />
              </Typography>
              <StyleTypography className="property--text">
                {`${data.floor_level} ${labels.floor}`}
              </StyleTypography>
            </Grid>
          ) : null}
        </Grid>
      </CardContent>
    </StyleCard>
  );
}

export default injectIntl(CardTheme2);
